import axios from 'axios'
import { IDownloadResourceResp } from '../modules/OrganizationDetails/types'

interface IDownloadResourceFromUri {
  downloadedResourceResp: Array<IDownloadResourceResp>
  isResourceDownloading: boolean
  setIsResourceDownloading: React.Dispatch<React.SetStateAction<boolean>>
  setResourcesFailedToDownload?: React.Dispatch<React.SetStateAction<string[]>>
  setSelectedSites?: React.Dispatch<React.SetStateAction<Array<any>>>
}

const downloadResourceFromUri = async ({
  downloadedResourceResp = [],
  isResourceDownloading,
  setIsResourceDownloading,
  setResourcesFailedToDownload,
  setSelectedSites,
}: IDownloadResourceFromUri) => {
  if (isResourceDownloading && downloadedResourceResp?.length > 0) {
    for (let index = 0; index < downloadedResourceResp.length; index++) {
      const siteResponse = downloadedResourceResp[index]
      try {
        const response = await axios.get(siteResponse.preSignedUri, {
          responseType: 'arraybuffer',
        })

        // Create a temporary URL for the downloaded file
        const url = URL.createObjectURL(new Blob([response.data]))

        // Use the temporary URL to trigger the file download
        const link = document.createElement('a')
        link.href = url
        link.download = `${siteResponse?.fileName}.zip` ?? 'resource1.zip' // Set the desired file name
        link.click()

        // Clean up the temporary URL
        URL.revokeObjectURL(url)

        if (index === downloadedResourceResp.length - 1) {
          setIsResourceDownloading(false)
          if (setSelectedSites) setSelectedSites([])
        }
      } catch (error) {
        console.error('Error downloading the file:', error)
        if (setResourcesFailedToDownload) {
          setResourcesFailedToDownload((prevResources) => [
            ...prevResources,
            siteResponse?.fileName,
          ])
        }
        if (index === downloadedResourceResp.length - 1) {
          setIsResourceDownloading(false)
          if (setSelectedSites) setSelectedSites([])
        }
      }
    }
  }
}

const downloadFileFromBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename

  document.body.appendChild(link)

  link.click()

  link.remove()

  URL.revokeObjectURL(url)
}

export { downloadResourceFromUri, downloadFileFromBlob }
